<template>
  <div class="qr-code">
    <qrcode-vue
      :value="text"
      :size="size"
      :level="errorLevel"
      :background="bgColor"
      :foreground="color"
      :margin="margin"
      :render-as="renderAs"
      role="presentation"
    />
  </div>
</template>
<script setup lang="ts">
import QrcodeVue, { type Level, type RenderAs } from 'qrcode.vue';

withDefaults(
  defineProps<{
    text: string;
    size?: number;
    errorLevel?: Level;
    bgColor?: string;
    color?: string;
    margin?: number;
    renderAs?: RenderAs;
  }>(),
  {
    text: '',
    size: 200,
    errorLevel: 'H',
    bgColor: '#ffffff',
    color: '#000000',
    margin: 0,
    renderAs: 'svg',
  },
);
</script>
